import { render, staticRenderFns } from "./checkoutPayment.vue?vue&type=template&id=359e94ec&scoped=true&"
import script from "./checkoutPayment.vue?vue&type=script&lang=ts&"
export * from "./checkoutPayment.vue?vue&type=script&lang=ts&"
import style0 from "./checkoutPayment.vue?vue&type=style&index=0&id=359e94ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e94ec",
  null
  
)

export default component.exports